
import { Infomation } from '@/pages/index/components/news-mixin/model'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component

export default class extends Vue {
  @Prop() private item!: Infomation
  @Prop() private menuTitle!: string
  showDetail () {
    window.open(`/infoNews.html#/news/${this.item.id}/${this.menuTitle}`)
  }
}
